import { createClient } from "@supabase/supabase-js";

const projUrl = "https://ibawrhzziezhlvfqlybr.supabase.co";
const pubApiKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImliYXdyaHp6aWV6aGx2ZnFseWJyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjI5MzM0MDAsImV4cCI6MjA3ODUwOTQwMH0.ZeNeCLwifB1s8hIwZFdhIOiRE3OyKPqje3jKIg4JAr4";

export const supabase = createClient(projUrl, pubApiKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
  },
});

// Tipi per il database
export interface GameScore {
  id?: string;
  user_id: string;
  email: string;
  first_name?: string;
  last_name?: string;
  personaggio_selezionato: number;
  score: number;
  created_at?: string;
  update?: string;
}

export interface UserProfile {
  id: string;
  email: string;
  full_name?: string;
  avatar_url?: string;
}
